import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store/store";

// ⬇️ Add this import
import { PopupProvider } from "./utils/PopupContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PopupProvider>
        <App />
      </PopupProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
